import { CaseSlideItem } from '@/components/CasesChunkedSlider/types';
import { CaseStudyDto } from '@/types/case-studies';

export const mapCaseToSlideItem = (caseStudy?: CaseStudyDto | null): CaseSlideItem[] => {
	const preview = caseStudy?.cardPreview?.[0];
	if (!caseStudy || !preview) return [];

	return [
		{
			...preview,
			tags: caseStudy.tags,
			awards: caseStudy.awards
		}
	];
};
